import {
  Table,
  InputGroup,
  Button,
  Dropdown,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";
import { CSVLink } from "react-csv";
import printJS from "print-js";
import {
  BookIcon,
  CalendarIcon,
  CubeIcon,
  DeleteIcon,
  EditIcon,
  ExportIcon,
  FIleUploadLineIcon,
  FilterCollapseIcon,
  MoneyDollarIcon,
  PrintIcon,
  RecieptIcon,
} from "../Icons";
import "./../../assets/scss/reports/cashbook.scss";
import { useEffect, useRef, useState } from "react";
import DateRangePicker from "../utils/DateRangePicker";
import CachedIcon from "mdi-react/CachedIcon";
import { FilterTwoIcon, PDFIcon, ExcelIcon } from "../Icons";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import DownloadIcon from "mdi-react/DownloadOutlineIcon";
import { queryActions, reportActions } from "../../utils/reactQueryActions";
import useDebounce, {
  useCurrencies,
  useGetFetchQuery,
  useIsAdmin,
  useIsCashier,
  useIsProcurement,
  useIsSales,
  useIsStore,
  useLocalStorage,
  useQueryParams,
  useResolveRootRoles,
  useScrollTop,
  useUnits,
} from "../../utils/hooks";
import queryString from "query-string";
import { appSettings, services } from "../../config";
import { useMutation, useQuery, useQueryClient } from "react-query";
import currency from "currency.js";
import { format, parse, parseISO } from "date-fns";

import ReactPaginate from "react-paginate";
import {
  defaultSelectValue,
  formatForQty,
  itemsStatus,
  itemTypeLabel,
  paginationOptions,
  qtyFormat,
  qtyFormatToString,
  returnStorageLocationName,
  scrollToTop,
  sortOptions,
} from "../../utils/helpers";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import { useAuth } from "../../hooks/useAuth";
import UpdateItemModal from "../UpdateItemModal";
// import NewItemModal from "../NewItemModal";
// import PurchaseDialog from "../PurchaseDialog";
// import NewItemServiceModal from "../NewItemServiceModal";
import NewItemModalWrapper from "../NewItemModalWrapper";
// import NewVendorModal from "../NewVendorModal";
import BatchesModal from "./BatchesModal";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import LoginDialog from "../LoginDialog";
import ConfirmDialog from "../ConfirmDialogue";
import { toast } from "react-toastify";
import CubeOutline from "mdi-react/CubeOutlineIcon";
import { Link } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import Select from "react-select";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import ItemsTable from "../utils/ItemsTable";
import TableComponent from "../TableComponent";
import ConvertQuantity, { QuantityLabel } from "../utils/ConvertQuantity";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import ModalLoader from "../utils/ModalLoader";
import UpdateItemPriceModal from "../UpdateItemPriceModal";
// import QuantityConversionModal from "../QuantityConversionModal";
import GRNDialog from "../GRNDialog";
import AddItemSizeDialog from "../modals/AddItemSizeModal";
// import ItemService from "../../hooks/ItemService";
import { isArray, isEmpty, lowerCase, truncate, uniq } from "lodash";
import BarcodeIcon from "mdi-react/BarcodeIcon";
import UpdateImageModal from "../DisplayItemImages";
import { fetchActionsUtil } from "../../utils/helpers";
import { read, utils } from "xlsx";
import * as yup from "yup";
import { uniqBy } from "lodash";
import ItemExchangeRateModal from "../modals/ItemExchangeRateModal";
import { IsPrivileged, useHasPriviledge } from "../DisplayChildElement";
import EditBatchHistoryModal from "./EditBatchHistoryModal";
import CashIcon from "mdi-react/CashIcon";
import ItemPriceChangeModal from "../modals/ItemPriceChangeModal";
import SettingsIcon from "mdi-react/SettingsIcon";
import WarehouseSettingsModal from "../modals/WarehouseSettingsModal";
import CogSyncOutlineIcon from "mdi-react/CogSyncOutlineIcon";
import StorageLocation from "../warehouse/StorageLocation";
import NewATCModal from "../ATC/NewATCModal";
import { EyeIcon } from "lucide-react";

export default function InternalTransfer({ ItemStatus = "" }) {
  useScrollTop();

  const queryClient = useQueryClient();
  const isSales = useIsSales();
  const { checkForPriviledge } = useHasPriviledge();

  const [isLoading, setIsLoading] = useState(false);
  const { backendUrl, isIronRod, isCement } = useAuth();
  const isAdmin = useIsAdmin();
  const isStore = useIsStore();
  const isCashier = useIsCashier();
  const isProcurement = useIsProcurement();
  const itemMeasurements = useStoreState(state => state.itemMeasurements);
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [showFilter, setShowFilter] = useLocalStorage("showFilter", true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showUpdatePriceModal, setShowUpdatePriceModal] = useState(false);
  const [showUpdateImageModal, setShowUpdateImageModal] = useState(false);
  const [showItemExchangeRateModal, setShowItemExchangeRateModal] = useState(
    false
  );
  const [showItemPriceChangeModal, setShowItemPriceChangeModal] = useState(
    false
  );

  const { isPrivileged } = useResolveRootRoles();
  const { prevailingCurrencySymbol } = useCurrencies();
  const generalSettings = useStoreState(state => state.generalSettings);
  const { convertQtyValueToHumanReadableUOM } = useUnits();

  const [showUpdateInventoryModal, setShowUpdateInventoryModal] = useState(
    false
  );
  const [showBatchesModal, setShowBatchesModal] = useState(false);
  const [
    showCreateNewInventoryModal,
    setShowCreateNewInventoryModal,
  ] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState();

  const [showBatchHistoryModal, setShowBatchHistoryModal] = useState(false);
  const [itemBarCode, setItemBarCode] = useState("");
  const [
    displaySalesInventoryModal,
    setDisplayInventorySettingsModal,
  ] = useState(false);
  const [salesInventorySetting, setSalesInventorySetting] = useState({
    W_ID: "",
    warehouseName: "",
  });

  // ATC MODAL
  const [showCreateNewATCModal, setShowCreateNewATCModal] = useState(false);

  const initialFilterParams = {
    page: 1,
    limit: 40,
  };

  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...queryParams,
    ...initialFilterParams,
  });

  const [excelData, setExcelData] = useState([]);

  const CSVLinkRef = useRef(null);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const debouncedFilterParams = useDebounce(filterParams, 500);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const fetchTransactions = async queryParams => {
    const { page, limit, startDate, endDate } = queryParams;
    // Build URL with optional date filters if needed
    let url = `${backendUrl}/api/invoice/get-transaction-per-branch?page=${page}&limit=${limit}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message);
    }

    const result = await response.json();
    // The API returns { data: { transactions, count, startIndex, endIndex } }
    // We map 'transactions' to 'items' so the rest of the component works
    return {
      items: result.data.transactions,
      count: result.data.count,
      startIndex: result.data.startIndex,
      endIndex: result.data.endIndex,
    };
  };

  const { data = { count: 0, items: [] }, refetch } = useQuery(
    ["transactions", queryParams], // new key
    () => fetchTransactions(queryParams),
    { keepPreviousData: true }
  );

  const handleShowBatches = item => {
    setSelectedItem(item);
    setShowBatchesModal(true);
  };

  // DELETE
  const deleteItem = async payload => {
    let response = await fetch(`${backendUrl}/api/items/delete`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteMutation = useMutation(payload => deleteItem(payload), {
    onSuccess: ({ message, data: { item } }) => {
      toast.success(message);

      // WHO ADDED THIS ?
      queryClient.setQueryData(
        [queryActions.ITEMS, queryParams, ItemStatus],
        data => {
          if (data?.items) {
            data.items = data.items.filter(el => el.Bar_Code !== item.Bar_Code);
          }
          return data;
        }
      );
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });
  const handleDeleteItem = async item => {
    if (await LoginDialog()) {
      if (
        await ConfirmDialog({
          title: "Delete Item",
          description:
            "Are you sure you want to delete this Item from your inventory",
          type: "danger",
        })
      ) {
        deleteMutation.mutate(item);
      }
    }
  };

  // ADD FROM EXCEL
  const addMultipleItems = async payload => {
    let response = await fetch(`${backendUrl}/api/items/add-stock-multiple`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const addMultipleItemsMutation = useMutation(
    payload => addMultipleItems(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams({
      ...initialFilterParams,
    });
  };

  const handleSelectedItem = item => {
    setFilterParams({
      ...filterParams,
      Bar_Code: item.Bar_Code,
      itemName: item.Item_Name,
      showAllItems: true,
    });
    setShowItemsPopover(false);
  };

  const editPrice = async el => {
    if (await LoginDialog()) {
      setSelectedItem(el);
      setShowUpdatePriceModal(true);
    }
  };

  const printGRN = async InvoiceNo => {
    await GRNDialog({
      title: "Transaction posted successfully",
      // description: "...",
      InvoiceNo,
    });
  };

  const handleEditSizes = async item => {
    const sizes = await getItemSizes(item);

    if (sizes) {
      const data = await AddItemSizeDialog({
        item,
        maxQuantity: item.Quantity,
        previousSizes: sizes,
      });
      if (data === false) return;
      if (data?.sizesAndColours) {
        saveItemSizesMutation.mutate({ sizes: data?.sizesAndColours, item });
      }
    }
  };

  const getItemSizes = item => {
    return new Promise(async (resolve, reject) => {
      try {
        setIsLoading(true);
        let response = await fetch(
          `${backendUrl}/api/items/get-item/${item.Bar_Code}`,
          {
            headers: {
              Accept: "Application/json",
              "Content-Type": "Application/json",
            },
            credentials: "include",
          }
        );

        if (!response.ok) {
          response = await response.json();
          toast.error(response.message);
        } else {
          const {
            data: { sizes },
          } = await response.json();

          resolve(sizes);
        }
      } catch (err) {
        console.log(err);
        toast.error("Unable to perform action");
        reject();
      } finally {
        setIsLoading(false);
      }
    });
  };

  const saveItemSizes = async payload => {
    let response = await fetch(`${backendUrl}/api/items/sizes/save`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const saveItemSizesMutation = useMutation(payload => saveItemSizes(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      // setItemBarcodeToEdit(null);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const turnOFFandON = async Bar_Code => {
    if (!Bar_Code) return toast.error(`Add Bar Code`);
    await fetchActionsUtil(
      `${backendUrl}/api/items/update-showInStore`,
      "POST",
      "",
      { Bar_Code }
    );
    refetch();
  };

  const updateShowInStore = async (Bar_Code, status) => {
    if (status) {
      turnOFFandON(Bar_Code);
    } else {
      if (generalSettings.store) {
        turnOFFandON(Bar_Code);
      } else {
        toast.error("Not subscribed");
      }
    }
  };

  const tableBodyData = (el, index) => {
    const rowNumber = data?.startIndex + index + 1;
    return (
      <>
        <td>{rowNumber}</td>
        <td>{el.Trans_ID}</td>
        <td>{el.Cust_ID}</td>
        <td>{el.Username}</td>
        <td>{el.targetBranchCompany}</td>
        <td>{el.targetBranchName}</td>
        <td>{el.ItemName}</td>
        <td>{currency(el.Amount_Due, { symbol: "₦" }).format()}</td>
        <td>{currency(el.Amount_Paid, { symbol: "₦" }).format()}</td>
        <td>{currency(el.Balance, { symbol: "₦" }).format()}</td>
        <td>{el.Payment_Type}</td>
        <td>{el.Payment_Method}</td>\
        <td>
          {el.Trans_Date
            ? format(parseISO(el.Trans_Date), "dd MMM yyyy")
            : "..."}
        </td>
      </>
    );
  };
  const tableHead = () => {
    return (
      <thead>
        <tr>
          <th>S/N</th>
          <th>Transaction ID</th>
          <th>Customer ID</th>
          <th>User Name</th>
          <th>Company</th>
          <th>Branch</th>
          <th>Item Name</th>
          <th>Amount Due</th>
          <th>Amount Paid</th>
          <th>Balance</th>
          <th>Payment Type</th>
          <th>Payment Method</th>
          <th>Transaction Date</th>
        </tr>
      </thead>
    );
  };
  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    const { limit, page, ...rest } = queryParams;

    const responses = await Promise.all([
      fetchExcelData(
        `${backendUrl}/api/items?${queryString.stringify(rest)}`,
        "GET"
      ),
      fetchActionsUtil(
        `${backendUrl}/api/items/stats?${queryString.stringify(rest)}`,
        "GET"
      ),
    ]);

    const { data: statData } = responses[1];

    let exData = responses[0];

    const company = exData.data?.company?.CompName;

    // console.log(exData.data);
    exData = exData.data.items.map(row => ({
      ...row,
      Date_Log: format(new Date(row.Date_Log), "dd-MMM-yyyy"),
    }));

    exData = exData.map((d, i) => [
      data?.startIndex + i + 1,
      d.Bar_Code,
      d.Item_Name,
      d.Cat_Name,
      d.Product_Name,
      d.Item_Desc,

      // UOM LOGIC
      d?.uomId
        ? convertQtyValueToHumanReadableUOM({
            quantity: d.Quantity,
            uomId: d.uomId,
          })
        : isIronRod
        ? qtyFormatToString(
            qtyFormat(d.Quantity, d.Item_Desc, itemMeasurements)
          )
        : d.Quantity,

      currency(d?.UnitCost, {
        symbol: "",
      }).format(),
      currency(d?.UnitPrice, {
        symbol: "",
      }).format(),

      // MEDBURY FIELDS
      ...(appSettings.isMedbury
        ? [d?.Pack_Size, d?.Generic_Configuration, d?.Tier, d?.Branded_Generic]
        : []),
      d.Date_Log,
    ]);

    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy k:mm:ss z"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy k:mm:ss z")}`
        : "";

    const category = rest?.category || "All";
    const manufacturer = rest?.product || "All";
    const itemType = rest?.itemType || "All";
    const storageLocation = rest?.itemsFromStorageLocation || "All";

    exData = [
      [company],
      ["Inventory Entry Report"],
      [date],
      [`Category: ${category}`],
      [`Manufacturer: ${manufacturer}`],
      [`Storage Location: ${storageLocation}`],
      [`Inventory Type: ${itemType}`],
      [""],
      [
        "S/N",
        "Item Code",
        "Item Name",
        "Category",
        "Manufacturer",
        "Item Desc",
        "QTY",
        "Unit Cost",
        "Unit Price",

        // MEDBURY FIELDS
        ...(appSettings.isMedbury
          ? ["Pack Size", "Generic Configuration", "Tier", "Branded/Generic"]
          : []),
        "Post time",
      ],
      ...exData,
      [""],

      //
      [
        "Total Inventory",
        currency(statData?.totalInventoryBatch, {
          symbol: "",
          precision: 2,
          format: formatForQty,
        }).format(),
      ],

      //
      ...(!isSales
        ? [
            [
              "Value In Stock",
              currency(statData?.valueInStock, {
                symbol: prevailingCurrencySymbol,
              }).format(),
            ],
            [
              "Expected Sales Value",
              currency(statData?.estimatedValueInStock, {
                symbol: prevailingCurrencySymbol,
              }).format(),
            ],
          ]
        : []),

      //
      ...(checkForPriviledge({
        parentName: "Supply Center",
      })
        ? [
            [
              "Inventory Shipped",
              currency(statData?.inventoryShipped, {
                symbol: prevailingCurrencySymbol,
              }).format(),
            ],
          ]
        : []),
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  function handleFile({ eventData: e, type }) {
    /*  toast.info("Service not Available");
    return; */
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async function(e) {
        const workbook = read(e.target.result, {
          cellDates: true,
          dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
        });
        let rows = utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          {
            defval: "",
            dateNF: "yyyy-MM-dd HH:mm:ss.SSS",
          }
        );
        //  console.log("excel", rows);

        //--
        if (
          !(await ConfirmDialog({
            title: "Are you sure?",
            description: "You want to import",
          }))
        ) {
          return;
        }
        // TODO - validate excel
        let schema = yup.object().shape({
          items: yup.array().of(
            yup.object({
              Vendor_ID: yup.string(),
              vendorName: yup.string(),
              Item_Type: yup.string(),
              Item_Code: yup.string().required(),
              New_Item_Code: yup.string(),
              Batch_Name: yup.string(),
              Item_Name: yup.string().required(),
              InvoiceNo: yup.string(),
              Item_Desc: yup.string(),
              Unit: yup.string().required(),
              Usage: yup.string(),
              UnitCost: yup.string().required(),
              Freight: yup.string(),
              LandingUnitCost: yup.string(),
              Quantity: yup.number().required(),
              ManDate: yup.string().default(new Date().toISOString()),
              ExpireDate: yup.string().default(new Date().toISOString()),
              Date_Log: yup.string().required(),
              Manufacturer: yup.string(),
              Category: yup.string(),
              Branch: yup.string(),
              Minimum_Level: yup.string().default("0"),
              Tax: yup.string(),
              Vat_5: yup.string(),
              UnitPrice: yup.string().required(),
              MaximumLevel: yup.string().default("0"),
              DriverName: yup.string(),
              DriverPhoneNumber: yup.string(),
              TruckNumber: yup.string(),
              DeliveryDate: yup.string(),
              showInStore: yup.string(),
              addDiscount: yup.string().default("0"),
              Profit: yup.string().default("0"),
              Incentive: yup.string().default("0"),
              pcsPriceDistributor: yup.string(),
              marginType: yup.string().default("Fixed"),
              marginPercentage: yup.string().default("0"),
              incentiveType: yup.string().default("Fixed"),
              incentivePercentage: yup.string().default("0"),
              age: yup.string(),
              ageDurationValue: yup.string(),
              parentBatchBarCode: yup.string(),
              parentBatchItemName: yup.string(),
              ItemStatus: yup.string(),
              InvoiceAmount: yup.string().default("0"),
              Total_Freight: yup.string().default("0"),
              totalLandingCost: yup.string().default("0"),
              totalDiscount: yup.string(),
              freightVendor_ID: yup.string(),
              Pack_Size: yup.string(),
              Generic_Configuration: yup.string(),
              Tier: yup.string(),
              Branded_Generic: yup.string(),
              Batch_Number: yup.string(),
              Serial_Number: yup.string(),
              currency: yup
                .string()
                .default(generalSettings?.prevailingCurrency),

              ...(type === "INSERT_ITEMS"
                ? {
                    baseUOMUnitPrice: yup.number().required(),
                    baseQty: yup.number().required(),
                    uomId: yup.string().when("baseQty", {
                      is: baseQty => baseQty > 1,
                      then: schema =>
                        schema.required(
                          "uomId is required when baseQty is more than 1"
                        ),
                      otherwise: schema => schema.nullable(),
                    }),
                  }
                : {}),
            })
          ),
        });
        try {
          // VALIDATE EXCEL
          await schema.validate({ items: rows });

          if (type === "INSERT_ITEMS") {
            // Check for duplicate Item_Codes in the Excel data
            const itemCodeCounts = rows.reduce((acc, row) => {
              acc[row.Item_Code] = (acc[row.Item_Code] || 0) + 1;
              return acc;
            }, {});

            const duplicateItemCodes = Object.keys(itemCodeCounts).filter(
              itemCode => itemCodeCounts[itemCode] > 1
            );

            if (duplicateItemCodes.length > 0) {
              return toast.error(
                `Duplicate Item_Codes found in the Excel data: ${duplicateItemCodes.join(
                  ", "
                )}`
              );
            }
          }

          // General Clean up
          rows = rows.map(el => ({
            ...el,
            Bar_Code: el.Item_Code,
            ManDate: el?.ManDate ? el?.ManDate : el?.Date_Log,
            ExpireDate: el?.ExpireDate ? el?.ExpireDate : el?.Date_Log,
            Reorder_Level: el.Minimum_Level,
          }));

          //
          if (generalSettings?.itemsRequiresSerialNumber) {
            // Group by and clean up
            const uniqueByBar_Code = uniqBy(
              rows.map(el => {
                el.LandingUnitCost = el?.LandingUnitCost
                  ? el?.LandingUnitCost
                  : el.UnitCost;
                el.totalLandingCost = el?.totalLandingCost
                  ? el?.totalLandingCost
                  : el.UnitCost;
                el.InvoiceAmount = el?.InvoiceAmount
                  ? el?.InvoiceAmount
                  : el.UnitCost;
                return {
                  ...el,
                  Bar_Code: el.Item_Code,
                  //  uniqueRow: `${el.Bar_Code}-${el.Batch_Number}`,
                };
              }),
              "Bar_Code"
            );

            rows = uniqueByBar_Code.map(el => {
              const foundItems = rows.filter(
                rowItem => String(rowItem.Bar_Code) == String(el.Bar_Code)
              );
              return {
                ...el,
                ...(type === "RESTOCK"
                  ? {
                      InvoiceAmount: foundItems
                        .map(el => el?.InvoiceAmount || 0)
                        .reduce((a, b) => currency(a).add(b).value),
                      Total_Freight: foundItems
                        .map(el => el?.Total_Freight || 0)
                        .reduce((a, b) => currency(a).add(b).value),
                      totalLandingCost: foundItems
                        .map(el => el?.totalLandingCost || 0)
                        .reduce((a, b) => currency(a).add(b).value),
                    }
                  : {}),
                Quantity: foundItems?.length,
                serialNumbers: foundItems.map(el => ({
                  serialNum: el.Serial_Number,
                })),
              };
            });

            // TODO - Do not mix vendors

            // TODO - Ensure all dates are valid

            //
          }

          // console.log(rows);

          if (type === "RESTOCK") {
            addMultipleItemsMutation.mutate({
              items: rows.map(el => ({
                ...el,
                New_Bar_Code: el.New_Item_Code,
                Bar_Code: el.Item_Code,
                Margin: el.Profit,
                Cat_Name: el.Category,
                PurchasePrice: el.UnitCost,
                UnitCost: el?.LandingUnitCost,
                Batch_Name: el.Batch_Number,
                InvoiceNo: el?.InvoiceNo
                  ? String(el?.InvoiceNo)
                  : `IVN${Date.now()}`,
              })),
              type, // "RESTOCK"
            });
            return;
          }

          addMultipleItemsMutation.mutate({
            items: rows.map(el => ({
              ...el,
              New_Bar_Code: el.New_Item_Code,
              Bar_Code: el.Item_Code,
              Margin: el.Profit,
              Cat_Name: el.Category,
              PurchasePrice: el.UnitCost,
              UnitCost: el?.UnitCost,
              Batch_Name: el.Batch_Number,
              InvoiceNo: el?.InvoiceNo
                ? String(el?.InvoiceNo)
                : `IVN${Date.now()}`,
            })),
            type, // "INSERT_ITEMS"  "CHANGE_PRICES" "RESTOCK"
          });

          //   resolve(validData);
        } catch (err) {
          console.log(err);
          toast.error(err.name);
          toast.error(JSON.stringify(err.errors));
        }
      };
      reader.readAsArrayBuffer(file);
    }
    e.target.value = "";
  }
  // isPrivilegesd

  const handleSalesInventorySettingsClick = ({ id, name }) => {
    setSalesInventorySetting({
      ...salesInventorySetting,
      W_ID: id,
      warehouseName: name,
    });
    setDisplayInventorySettingsModal(true);
  };

  const handleSyncSalesInventory = useMutation(
    payload =>
      fetchActionsUtil(
        `${backendUrl}/api/items/sync-sales-inventory`,
        "POST",
        "",
        payload
      ),
    {
      onSuccess: data => {
        toast.success(data?.message);
      },
      onError: data => {
        toast.error("Unable to perform action", data?.massage);
      },
    }
  );

  return (
    <IsPrivileged roleName={["Sales Inventory", "Inventory Entry"]}>
      <section className="">
        <main className="cash-book">
          <div className="content">
            <div className="content-main">
              <div className={`filter-area ${showFilter ? "open" : "close"}`}>
                <div className="filter-header">
                  <h2>
                    <FilterTwoIcon /> Filters
                  </h2>

                  <Button
                    variant="white"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <FilterCollapseIcon />
                  </Button>
                </div>
                <div className="filter-body">
                  <Form>
                    <div className="body">
                      <Form.Group className="mb-2-5">
                        <Form.Label>Item Code</Form.Label>

                        <InputGroup>
                          <Form.Control
                            name="Bar_Code"
                            placeholder="Enter Item Code"
                            value={filterParams?.Bar_Code}
                            onChange={e => handleFilterParamsChange(e)}
                          />

                          <Popover
                            isOpen={showItemsPopover}
                            onClickOutside={() => setShowItemsPopover(false)}
                            content={() => (
                              <ItemsTable
                                handleSelectedItem={handleSelectedItem}
                                defaultSort={"name-asc"}
                              />
                            )}
                            position="bottom"
                          >
                            <InputGroup.Text
                              className="p-cursor"
                              onClick={() =>
                                setShowItemsPopover(!showItemsPopover)
                              }
                            >
                              <MagnifyIcon />
                            </InputGroup.Text>
                          </Popover>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group className="mb-2-5">
                        <Form.Label>Item Name</Form.Label>
                        <Form.Control
                          name="itemName"
                          value={filterParams?.itemName}
                          placeholder="Enter Item Name"
                          onChange={e => handleFilterParamsChange(e)}
                          disabled
                        />
                      </Form.Group>

                      {/** Inventory Status: THE USER CAN PICK IF NOT PRE_SELECTED FROM PROPS */}
                      {generalSettings?.itemStatusSettings ? (
                        <Form.Group className=" mb-3 pb-2">
                          <Form.Label className="mb-1">
                            Inventory Status
                          </Form.Label>
                          <Select
                            classNamePrefix={`form-select`}
                            options={itemsStatus}
                            value={itemsStatus?.find(
                              el => el.value === filterParams.ItemStatus
                            )}
                            onChange={selected => {
                              setFilterParams({
                                ...filterParams,
                                ItemStatus: selected?.value,
                              });
                            }}
                            isClearable={true}
                          />
                        </Form.Group>
                      ) : null}

                      {/* <Form.Group className="mb-2-5">
                        <Form.Label>Storage Location</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="itemsFromStorageLocation"
                          isSearchable={true}
                          key={data?.storageLocations}
                          onChange={selected => {
                            setFilterParams({
                              ...filterParams,
                              itemsFromStorageLocation: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.StorageLocation,
                            data?.StorageLocation,
                            {
                              value: "",
                              label: "All",
                            }
                          )}
                          options={data?.storageLocations || []}
                        />
                      </Form.Group> */}

                      <Form.Group className="mb-2-5">
                        <Form.Label>Product Name</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="product"
                          isSearchable={true}
                          key={data?.product_name}
                          onChange={selected => {
                            setFilterParams({
                              ...filterParams,
                              product_name: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.product_name,
                            data?.product_name,
                            {
                              value: "",
                              label: "All",
                            }
                          )}
                          options={data?.product_name || []}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Category</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="category"
                          isSearchable={true}
                          key={data?.categories}
                          onChange={selected => {
                            setFilterParams({
                              ...filterParams,
                              category: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.categories,
                            data?.categories,
                            {
                              value: "",
                              label: "All",
                            }
                          )}
                          options={data?.categories || []}
                        />
                      </Form.Group>
                      {/* <Form.Group className="mb-2-5">
                        <Form.Label>Plant</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="plant"
                          isSearchable={true}
                          key={data?.plants}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              plant: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.plant,
                            data?.plants,
                            { value: "", label: "All" },
                          )}
                          options={data?.plants || []}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Region</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="region"
                          isSearchable={true}
                          key={data?.regions}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              region: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.region,
                            data?.regions,
                            { value: "", label: "All" },
                          )}
                          options={data?.regions || []}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Depot</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="depot"
                          isSearchable={true}
                          key={data?.depots}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              depot: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.depot,
                            data?.depots,
                            { value: "", label: "All" },
                          )}
                          options={data?.depots || []}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Status</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="status"
                          isSearchable={true}
                          key={data?.status}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              status: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(
                            queryParams?.status,
                            data?.status,
                            { value: "", label: "All" },
                          )}
                          options={data?.status || []}
                        />
                      </Form.Group> */}

                      {/* <Form.Group className="mb-2-5">
                        <Form.Check
                          label="Bar Items"
                          name="enableBarItems"
                          className="ga-form-check fs-6"
                          checked={filterParams.enableBarItems || false}
                          onChange={(e) => handleFilterParamsChange(e)}
                        />
                      </Form.Group> */}

                      {/* NOT USEFUL, COPIED FROM DESKTOP */}
                      {/* <Form.Group className="mb-2-5">
                        <Form.Label>Branch</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="All"
                          name="branch"
                          isSearchable={true}
                          key={data?.branch}
                          onChange={selected => {
                            setFilterParams({
                              ...filterParams,
                              branch: selected.value,
                            });
                          }}
                          defaultValue={defaultSelectValue(queryParams?.branch, data?.branch, {
                            value: "",
                            label: "All",
                          })}
                          options={data?.branch || []}
                        />
                      </Form.Group> */}

                      {/* SHOW ALL, OR ONLY ITEMS WITH QUANTITY  */}
                      <Form.Group className="mb-2-5">
                        <Form.Check
                          label="Show All"
                          name="showAllItems"
                          className="ga-form-check fs-6"
                          checked={filterParams.showAllItems || false}
                          onChange={e => handleFilterParamsChange(e)}
                        />
                      </Form.Group>

                      <hr className="mt-3 mb-4" />

                      <Form.Group className="">
                        <Form.Label>Date Range</Form.Label>
                        <div className="position-relative">
                          <RsDateRangePicker
                            placement="topStart"
                            value={
                              filterParams.startDate && filterParams.endDate
                                ? [
                                    parse(
                                      filterParams.startDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                    parse(
                                      filterParams.endDate,
                                      "yyyy-MM-dd",
                                      new Date()
                                    ),
                                  ]
                                : []
                            }
                            onClean={() => clearDateRange()}
                            onOk={date => filterByDateRange(date)}
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="buttons rounded">
                      <Button onClick={() => reset()} variant="white">
                        Reset
                      </Button>
                      <Button onClick={() => search()} variant="primary">
                        Search
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="content-body">
                <header>
                  <h1>
                    {!showFilter && (
                      <button
                        onClick={() => setShowFilter(!showFilter)}
                        className="btn filter"
                      >
                        <FilterTwoIcon />
                      </button>
                    )}
                    Internal Transfer
                    <button
                      onClick={() => refetch()}
                      className="btn text-primary"
                      title="Refresh"
                    >
                      <CachedIcon />
                    </button>
                  </h1>
                  <div className="actions mr-5" style={{ zIndex: "3" }}>
                    {/* <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          width: "12rem",
                        }),
                      }}
                      classNamePrefix={`form-select-store`}
                      isSearchable={false}
                      placeholder="Sort By"
                      options={sortOptions}
                      value={sortOptions?.find(
                        el => el?.value === filterParams.sort
                      )}
                      onChange={({ value }) =>
                        setFilterParams({
                          ...filterParams,
                          page: 1,
                          sort: value,
                        })
                      }
                    />{" "} */}
                    <>
                      {isAdmin || isStore || isProcurement || isCashier ? (
                        <>
                          {/* STANDARD INVEX */}
                          {/* {isIronRod && (
                            <>
                              <Button
                                variant="primary"
                                onClick={() =>
                                  setShowCreateNewInventoryModal(true)
                                }
                              >
                                + Create New
                              </Button>

                              <button
                                onClick={() =>
                                  setShowUpdateInventoryModal(true)
                                }
                                className="btn sendSms"
                              >
                                Restock <FIleUploadLineIcon />
                              </button>
                            </>
                          )} */}

                          {/* {isCement && (
                            <>
                              <Link
                                className="btn btn-outline-primary px-3 d-flex align-items-center"
                                to="/load-atc"
                              >
                                Split & Load ATC
                              </Link>

                              <Button
                                variant="outline-primary"
                                onClick={() => setShowCreateNewATCModal(true)}
                              >
                                + Create SKU
                              </Button>
                            </>
                          )} */}
                        </>
                      ) : null}
                    </>
                    {/* <CSVLink
                      className="btn print d-none"
                      filename={`inventory Entry Report(${format(
                        new Date(),
                        "dd-MMM-yyyy hh:mm:ss a"
                      )}).csv`}
                      data={excelData}
                      ref={CSVLinkRef}
                    />
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        Export
                        <ExportIcon color="#008000" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelData}
                          className="p-cursor"
                        >
                          Excel <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/items/pdf/inventory-entry?${queryString.stringify(
                              rest
                            )}`}
                            target="_blank"
                          >
                            PDF <PDFIcon color="#ff0000" />
                          </a>
                        </Dropdown.Item>

                        <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/items/pdf/generate-barcodes?${queryString.stringify(
                              rest
                            )}`}
                            target="_blank"
                          >
                            Barcodes <BarcodeIcon />
                          </a>
                        </Dropdown.Item>

                        <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/items/pdf/stock-count-report?${queryString.stringify(
                              rest
                            )}`}
                            target="_blank"
                          >
                            Stock Count Report <PDFIcon color="#ff0000" />
                          </a>
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <a
                            href={`${backendUrl}/api/items/excel/stock-count-report?${queryString.stringify(
                              rest
                            )}`}
                            target="_blank"
                            download={"Stock_Count.xlsx"}
                          >
                            Stock Count Report <ExcelIcon color="#008000" />
                          </a>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        Import <ExcelIcon color="#008000" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="label"
                          className="p-cursor"
                          title="Import"
                        >
                          <input
                            type="file"
                            className="d-none"
                            onChange={e =>
                              handleFile({ eventData: e, type: "INSERT_ITEMS" })
                            }
                            accept=".xlsx"
                          />
                          Insert Items (No Accounting)
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="label"
                          className="p-cursor"
                          title="Import"
                        >
                          <input
                            type="file"
                            className="d-none"
                            onChange={e =>
                              handleFile({
                                eventData: e,
                                type: "CHANGE_PRICES",
                              })
                            }
                            accept=".xlsx"
                          />
                          Change Prices
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="label"
                          className="p-cursor"
                          title="Import"
                        >
                          <input
                            type="file"
                            className="d-none"
                            onChange={e =>
                              handleFile({ eventData: e, type: "RESTOCK" })
                            }
                            accept=".xlsx"
                          />
                          Restock Items
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        Templates <DownloadIcon />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item as="div">
                          <a
                            href={`/excel_templates/INVEX_INSERT_ITEMS_TEMPLATE.xlsx`}
                            target="_blank"
                            title="Download"
                            download=""
                          >
                            Insert Items Template
                          </a>
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <a
                            href={`/excel_templates/INVEX_CHANGE_PRICE_TEMPLATE.xlsx`}
                            target="_blank"
                            title="Download"
                            download=""
                          >
                            Change Price Template
                          </a>
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <a
                            href={`/excel_templates/INVEX_RESTOCK_ITEMS_TEMPLATE.xlsx`}
                            target="_blank"
                            title="Download"
                            download=""
                          >
                            Restock Template
                          </a>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        bsPrefix=""
                      >
                        <DotsVerticalIcon />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        {isAdmin && (
                          <>
                            <Dropdown.Item
                              as="button"
                              onClick={() => setShowItemPriceChangeModal(true)}
                            >
                              <CashIcon />
                              Unit Price Adjustment
                            </Dropdown.Item>

                            <Dropdown.Item
                              as="button"
                              onClick={() => setShowItemExchangeRateModal(true)}
                            >
                              <MoneyDollarIcon /> Exchange Rate
                            </Dropdown.Item>
                            <Dropdown.Item
                              as="button"
                              onClick={() => {
                                handleSalesInventorySettingsClick({
                                  name: "Sales Inventory",
                                  id: "INVENTORY",
                                });
                              }}
                            >
                              <SettingsIcon /> Settings (API / Webhooks)
                            </Dropdown.Item>

                            <Dropdown.Item
                              as="button"
                              onClick={() =>
                                handleSyncSalesInventory.mutate({
                                  ID: "INVENTORY",
                                })
                              }
                            >
                              <CogSyncOutlineIcon />
                              Synchronize Sales Inventory
                            </Dropdown.Item>
                          </>
                        )}
                      </Dropdown.Menu>
                    </Dropdown> */}
                  </div>
                </header>

                <div className="px-md-4">
                  <TableComponent
                    responsive
                    borderless
                    striped
                    hover
                    tableHeadsFunction={tableHead}
                    mainDataArray={data?.items} // now transactions
                    tableDataRowFunction={tableBodyData}
                    className="product-table"
                  />
                </div>

                <div className="d-flex justify-content-between px-3 align-items-center pagination">
                  <div className="pagination_left">
                    <p className="m-0 p-0">Show</p>
                    <select
                      value={queryParams.limit}
                      name="limit"
                      className="form-select "
                      onChange={e => handleSearchQueryChange(e)}
                    >
                      <option value="10">10 rows</option>
                      <option value="20">20 rows</option>
                      <option value="30">30 rows</option>
                      <option value="40">40 rows</option>
                      <option value="50">50 rows</option>
                      <option value="100">100 rows</option>
                    </select>
                  </div>

                  <ReactPaginate
                    {...paginationOptions}
                    pageCount={Math.ceil(data.count / queryParams.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={0}
                    onPageChange={({ selected }) => {
                      scrollToTop();
                      setQueryParams({
                        ...queryParams,
                        page: selected + 1,
                      });
                    }}
                    forcePage={queryParams.page - 1}
                  />
                </div>
              </div>
            </div>
          </div>

          {showUpdateInventoryModal && (
            <UpdateItemModal
              showUpdateInventoryModal={showUpdateInventoryModal}
              setShowUpdateInventoryModal={setShowUpdateInventoryModal}
              refetch={refetch}
              printGRN={printGRN}
              requiresApproval={generalSettings.restockRequiresApproval}
              requiresPONumber={generalSettings.restockRequiresPONumber}
            />
          )}

          {showCreateNewInventoryModal && (
            <NewItemModalWrapper
              setShowCreateNewInventoryModal={setShowCreateNewInventoryModal}
              showCreateNewInventoryModal={showCreateNewInventoryModal}
              refetch={refetch}
            />
          )}

          {showBatchesModal && selectedItem && (
            <BatchesModal
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              showBatchesModal={showBatchesModal}
              setShowBatchesModal={setShowBatchesModal}
            />
          )}

          {showUpdatePriceModal && selectedItem ? (
            <UpdateItemPriceModal
              showUpdatePriceModal={showUpdatePriceModal}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              setShowUpdatePriceModal={setShowUpdatePriceModal}
              refetch={refetch}
            />
          ) : null}

          {showUpdateImageModal && selectedItem ? (
            <UpdateImageModal
              showUpdatePriceModal={showUpdateImageModal}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              setShowUpdatePriceModal={setShowUpdateImageModal}
              refetch={refetch}
            />
          ) : null}

          {showItemExchangeRateModal && (
            <ItemExchangeRateModal
              showItemExchangeRateModal={showItemExchangeRateModal}
              setShowItemExchangeRateModal={setShowItemExchangeRateModal}
              refetch={refetch}
            />
          )}

          {showItemPriceChangeModal && (
            <ItemPriceChangeModal
              showItemPriceChangeModal={showItemPriceChangeModal}
              setShowItemPriceChangeModal={setShowItemPriceChangeModal}
              refetch={refetch}
            />
          )}

          {showBatchHistoryModal && (
            <EditBatchHistoryModal
              showBatchHistoryModal={showBatchHistoryModal}
              setShowBatchHistoryModal={setShowBatchHistoryModal}
              setBatchName={setItemBarCode}
              itemBarCode={itemBarCode}
              title={selectedBatch}
            />
          )}

          {displaySalesInventoryModal && (
            <WarehouseSettingsModal
              show={displaySalesInventoryModal}
              setShow={setDisplayInventorySettingsModal}
              warehouseSetting={salesInventorySetting}
            />
          )}

          {showCreateNewATCModal && (
            <NewATCModal
              showCreateNewATCModal={showCreateNewATCModal}
              setShowCreateNewATCModal={setShowCreateNewATCModal}
              refetch={refetch}
            />
          )}

          <ModalLoader
            show={
              isfetchingExcel ||
              isLoading ||
              saveItemSizesMutation.isLoading ||
              addMultipleItemsMutation.isLoading
            }
          />
        </main>
      </section>
    </IsPrivileged>
  );
}
